<template>
    <div class="page_chpc_lianxi flex-col">
        <div class="group_37 flex-row">
            <div class="group_38 flex-col">
                <div class="list_24 flex-col">
                    <div
                            class="list-items_1 flex-row justify-between"
                            style="background: #FAFAFA"
                            v-for="(item, index) in contactData"
                            :key="index"
                    >
                        <div class="block_10 flex-col">
                            <div class="image-text_41 flex-row justify-between">
                                <img class="label_1" referrerpolicy="no-referrer" :src="item.addressIcon" />
                                <span class="text-group_2" v-html="item.lanhutext0"></span>
                            </div>
                            <div class="text-group_59 flex-col">
                                <span class="text_12" v-html="item.lanhutext1"></span>
                                <span class="text_13" v-html="item.lanhutext2"></span>
                            </div>
                            <div class="text-wrapper_96 flex-row">
                                <span class="text_14" v-html="item.lanhutext3"></span>
                                <span class="text_15" v-html="item.lanhutext4"></span>
                                <span class="text_16" v-html="item.lanhutext5"></span>
                            </div>
                            <div v-if="item.slot1 === 1" class="box_30 flex-row">
                                <div class="text-wrapper_5">
                                    <span class="text_17">传真</span>
                                    <span class="text_18">:</span>
                                </div>
                                <span class="text_16">010-58204839</span>
                            </div>
                        </div>
                        <div class="group_2 flex-col" :style="{ backgroundImage: 'url(' + item.lanhuBg5 + ')' }"></div>
                    </div>
                </div>
                <div class="block_4 flex-row" style="background: #FAFAFA">
                    <div class="image-text_42 flex-row justify-between">
                        <img
                                class="label_2"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_address.png"
                        />
                        <div class="text-group_60 flex-col">
                            <span class="text_20">各地办事处</span>
                            <span class="text_21">
                武汉&nbsp;•&nbsp;广州&nbsp;•&nbsp;南京&nbsp;•&nbsp;成都&nbsp;•&nbsp;天津&nbsp;•&nbsp;合肥&nbsp;•&nbsp;无锡&nbsp;•&nbsp;西安
              </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {

        props: {
            contactData: {
                type: Array,
                required: true,
                default: () => []  // 默认空数组
            }
        },
        data() {
            return {
                /*
                contactData: [
                    {
                        lanhuBg0:'',
                        lanhuimage0:  '',
                        lanhutext0: '北京总公司',
                        lanhutext1: '北京市朝阳区建国路93号院万达广场8号楼2606室',
                        lanhutext2:
                            'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,&nbsp;Chaoyang&nbsp;District,&nbsp;Beijing&nbsp;100022,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '010-58204887',
                        lanhuBg5:'',
                        slot1: 1
                    },
                    {
                        lanhuBg0: '',
                        lanhuimage0: '',
                        lanhutext0: '上海分公司',
                        lanhutext1: '上海市黄浦区中山南一路768号博荟广场C座907室',
                        lanhutext2:
                            'Suite&nbsp;907,Tower&nbsp;C,&nbsp;No.&nbsp;768&nbsp;South&nbsp;1st&nbsp;Zhongshan&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '021-63331086',
                        lanhuBg5: '',
                    }
                ],

                 */


            };
        },
        methods: {}
    };
</script>

<style scoped lang="css"  >
    .page_chpc_lianxi {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .group_37 {
    }
    .flex-row
    {
        display: flex;
        flex-direction: row;
    }

    .group_38 {
        display: flex;
        flex-direction: column;
        align-items: center;  /* 新增：水平居中 */
        width: 100%;         /* 新增：确保容器宽度 */
        margin-bottom: 59px;
        padding-bottom: 1px;
    }
    flex-col {
        display: flex;
        flex-direction: column;
    }

    .block_1 {
        box-shadow: inset 0px -1px 0px 0px rgba(15, 140, 177, 0.07);
        background-color: rgba(255, 255, 255, 1);
        width: 1468px;
        justify-content: flex-center;
        padding: 15px 134px 15px 134px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }


    .text_69 {
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 44px;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
        margin-right: 5px;
    }


    .list_24 {
        min-width: 1200px;
        height: 760px;
        margin-top: 30px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .list-items_1 {
        min-width: 1200px;
        height: 365px;
        background-color: #FAFAFA;
        background-size: 100% 100%;
        margin: 0 1px 30px 0;
        padding: 34px 46px 72px 46px;

    }
    .list-items_1:hover {
        background: #FFFFFF;
        box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.2);
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-row {
         display: flex;
         flex-direction: row;
     }

    .block_10 {
        width: 650px;
        height: 257px;
        margin-bottom: 2px;
    }

    .image-text_41 {
        width: 152px;
        margin-right: 498px;
    }

    .label_1 {
        width: 22px;
        height: 30px;
        margin: 2px 0 1px 0;
    }

    .text-group_2 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text-group_59 {
        margin-top: 68px;
    }

    .text_12 {
        width: 401px;
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin-right: 250px;
    }

    .text_13 {
        width: 672px;
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 12px;
    }

    .text-wrapper_96 {

        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;          /* 强制不换行 */
        align-items: center;        /* 垂直居中（可选） */
        margin: 32px 0 0 0;         /* 移除右侧大边距，让容器占满宽度 */
        width: auto;                /* 或 100%，根据布局调整 */
    }

    .text_14 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 2px;
    }

    .text_15 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
    }

    .text_16 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin: 2px 0 0 15px;
    }

    .box_30 {
        width: 154px;
        margin: 25px 496px 0 0;

    }

    .text-wrapper_5 {

        height: 20px;
        overflow-wrap: break-word;
        font-size: 0;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        width: auto;
    }

    .text_17 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_18 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_19 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin-top: 1px;
    }

    .group_2 {
        width: 345px;
        height: 246px;
        margin-top: 13px;
    }

    .block_4 {
        min-width: 1200px;  /* 修改这里 */
        background: #FAFAFA;
        padding: 43px 44px 33px 44px; /* 调整为更合理的padding */
        display: flex;
        align-items: center; /* 新增：垂直居中 */
        margin: 30px auto 0;
    }
    .block_4:hover {
        background: #FFFFFF;
        box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.2);
    }

    .image-text_42 {
        min-width: 518px;
    }

    .label_2 {
        width: 22px;
        height: 30px;
        margin: 3px 0 39px 0;
    }

    .text-group_60 {
    }

    .text_20 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin-right: 364px;
    }

    .text_21 {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 20px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin-top: 11px;
    }


</style>
